if (!customElements.get('gabi-stl')) {
  class GabiStl extends HTMLElement {
    connectedCallback() {
      if (this.dataset.gabiGotowe) return;
      this.dataset.gabiGotowe = '1';

      this.querySelectorAll('[data-gabi-stl-kropka]').forEach((btn) => {
        btn.addEventListener('click', () => this.wybierz(btn));
      });
    }

    wybierz(btn) {
      const index = btn.dataset.index;

      this.querySelectorAll('[data-gabi-stl-kropka]').forEach((el) => {
        const aktywna = el === btn;
        el.classList.toggle('is-current', aktywna);
        el.setAttribute('aria-current', aktywna ? 'true' : 'false');
      });

      this.querySelectorAll('[data-gabi-stl-karta]').forEach((karta) => {
        karta.classList.toggle('is-wybrany', karta.dataset.gabiStlKarta === index);
      });
    }
  }

  customElements.define('gabi-stl', GabiStl);
}

if (!customElements.get('gabi-stl-szuflada')) {
  class GabiStlSzuflada extends HTMLElement {
    connectedCallback() {
      if (this.dataset.gabiGotowe) return;
      this.dataset.gabiGotowe = '1';

      this.trigger = document.querySelector('[aria-controls="' + this.id + '"]');
      this.zamknijBtn = this.querySelector('.gabi-stl-szuflada__zamknij');
      this.tlo = this.querySelector('.gabi-stl-szuflada__tlo');

      this.trigger?.addEventListener('click', () => this.otworz());
      this.zamknijBtn?.addEventListener('click', () => this.zamknij());
      this.tlo?.addEventListener('click', () => this.zamknij());
      this.addEventListener('keydown', (event) => this.naKlawisze(event));

      this.szerokosc = window.matchMedia('(min-width: 750px)');
      this.naSzerokosc = (event) => {
        if (event.matches) this.zamknij();
      };
      this.szerokosc.addEventListener('change', this.naSzerokosc);
    }

    disconnectedCallback() {
      this.szerokosc?.removeEventListener('change', this.naSzerokosc);
      if (this.classList.contains('is--open')) {
        document.body.classList.remove('overflow-hidden');
      }
    }

    otworz() {
      this.inert = false;
      this.classList.add('is--open');
      document.body.classList.add('overflow-hidden');
      this.trigger?.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => this.zamknijBtn?.focus());
    }

    zamknij() {
      if (!this.classList.contains('is--open')) return;

      this.classList.remove('is--open');
      this.inert = true;
      this.trigger?.setAttribute('aria-expanded', 'false');

      const innaSzuflada = document.querySelector('quick-cart-drawer.is--open, shop-the-look-drawer.is--open');
      if (!innaSzuflada) {
        document.body.classList.remove('overflow-hidden');
      }

      this.trigger?.focus();
    }

    naKlawisze(event) {
      if (!this.classList.contains('is--open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this.zamknij();
        return;
      }

      if (event.key !== 'Tab') return;

      const elementy = this.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!elementy.length) return;

      const pierwszy = elementy[0];
      const ostatni = elementy[elementy.length - 1];

      if (event.shiftKey && document.activeElement === pierwszy) {
        event.preventDefault();
        ostatni.focus();
      } else if (!event.shiftKey && document.activeElement === ostatni) {
        event.preventDefault();
        pierwszy.focus();
      }
    }
  }

  customElements.define('gabi-stl-szuflada', GabiStlSzuflada);
}
